/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Pricing
 * The Selling Partner API for Pricing helps you programmatically retrieve product pricing and offer information for Amazon Marketplace products.
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The HTTP method associated with the individual APIs being called as part of the batch request.
 */

export const HttpMethod = {
    Get: 'GET',
    Put: 'PUT',
    Patch: 'PATCH',
    Delete: 'DELETE',
    Post: 'POST',
} as const;

export type HttpMethod = typeof HttpMethod[keyof typeof HttpMethod];



